<div class="feature-detail-container" *ngIf="feature">
  <div class="detail-page">
    <!-- Back Navigation -->
    <button class="back-button" (click)="goBack()">
      <span class="back-icon">←</span> Back to Features
    </button>

    <!-- Feature Header -->
    <div class="feature-header">
      <div class="header-content">
        <div class="header-badges">
          <span class="category-badge">{{feature.Category}}</span>
          <span class="status-badge" [class.active]="feature.IsActive">
            {{feature.IsActive ? 'Live' : 'Inactive'}}
          </span>
        </div>
        <h1 class="feature-title">{{feature.Title}}</h1>
        <div class="feature-meta">
          <span class="meta-item">
            <strong>Updated:</strong> {{feature.UpdatedOn | date:'MMMM dd, yyyy'}}
          </span>
        </div>
      </div>
    </div>

    <!-- Feature Content -->
    <div class="feature-content">
      <div class="content-section">
        <h2 class="section-title">Release Details</h2>
        <div class="content-body" [innerHTML]="safeContent"></div>
      </div>

      <!-- Tags Section -->
      <div class="tags-section" *ngIf="feature.Tags?.length">
        <h3 class="tags-title">Tags</h3>
        <div class="tags-list">
          <span class="tag" *ngFor="let tag of feature.Tags">{{tag}}</span>
        </div>
      </div>
    </div>
  </div>
</div>